if (!customElements.get('hero-banner-swiper')) {
    class HeroBannerSwiper extends HTMLElement {
      swiper = null;

      connectedCallback() {
        if (typeof Swiper === 'undefined') {
          return;
        }

        const swiperEl = this.querySelector('.swiper');
        if (!swiperEl) {
          return;
        }

        const slideCount = parseInt(this.dataset.slideCount, 10) || 0;
        const hasMultipleSlides = slideCount > 1;
        const enableAutoplay = this.dataset.autoplay === 'true' && hasMultipleSlides;
        const enableLoop = this.dataset.loop === 'true' && hasMultipleSlides;
        const speed = parseInt(this.dataset.speed, 10) * 1000 || 5000;
        const isMobile = !window.matchMedia('(min-width: 768px)').matches;
        const showNavigation = isMobile ? this.dataset.showNavigationMobile === 'true' : this.dataset.showNavigationDesktop === 'true';
        const showPagination = isMobile ? this.dataset.showPaginationMobile === 'true' : this.dataset.showPaginationDesktop === 'true';

        const config = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: enableLoop,
          watchOverflow: true,
          speed: 600,
        };

        if (enableAutoplay) {
          config.autoplay = {
            delay: speed,
            disableOnInteraction: false,
          };
        }

        if (showPagination && hasMultipleSlides) {
          config.pagination = {
            el: swiperEl.querySelector('.swiper-pagination'),
            clickable: true,
          };
        }

        if (showNavigation && hasMultipleSlides) {
          config.navigation = {
            nextEl: swiperEl.querySelector('.swiper-button-next'),
            prevEl: swiperEl.querySelector('.swiper-button-prev'),
          };
        }

        this.swiper = new Swiper(swiperEl, config);

        if (enableAutoplay && this.swiper.autoplay) {
          this.onMouseEnter = () => this.swiper.autoplay.stop();
          this.onMouseLeave = () => this.swiper.autoplay.start();
          this.addEventListener('mouseenter', this.onMouseEnter);
          this.addEventListener('mouseleave', this.onMouseLeave);
        }
      }

      disconnectedCallback() {
        if (this.onMouseEnter) {
          this.removeEventListener('mouseenter', this.onMouseEnter);
          this.removeEventListener('mouseleave', this.onMouseLeave);
        }

        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    }

    customElements.define('hero-banner-swiper', HeroBannerSwiper);
  }